import { render, staticRenderFns } from "./EnterpriseStaff.vue?vue&type=template&id=31f41928"
import script from "./EnterpriseStaff.vue?vue&type=script&lang=js"
export * from "./EnterpriseStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports